import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import { AccordionPanel } from 'reaxl';
import FilterTitle from '../FilterTitle';
import FilterLocationForm from '../FilterLocationForm';

/**
 *  FilterLocation is a custom Filter component that is designed to be used as a Custom Filter type in the Filters Component.
 *  It allows the user to define both search radius and zip within a single filter.
 *  It uses the Filters provided onOptionChange callback on selection to handle the updating of any connected reducers
 *
 */
function FilterLocation(_ref) {
  let {
    collapsed,
    collapsedTitle,
    errors = {},
    filter = {},
    filters = {},
    filtersOrder,
    onOptionChange = () => {},
    onOptionsClear,
    resultCount,
    values = {},
    ...rest
  } = _ref;
  const title = /*#__PURE__*/_jsx(FilterTitle, {
    title: filter.label
  });
  return /*#__PURE__*/React.createElement(AccordionPanel, Object.assign({
    "data-cmp": "filterLocation",
    eventKey: filter.name,
    title: title
  }, rest), /*#__PURE__*/_jsx(FilterLocationForm, {
    filter: filter,
    filters: filters,
    errors: errors,
    onOptionChange: onOptionChange,
    onOptionsClear: onOptionsClear,
    resultCount: resultCount,
    values: values
  }), filter.children);
}
export default FilterLocation;